module.exports = __webpack_public_path__ + "img/nature-21.1ca7f18a.jpg";